module.exports = __webpack_public_path__ + "img/icon05.97b4e004.png";